/// <amd-module name="Repos/Messages/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\repos-messages\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Git from "Repos/Common/Contracts/Git";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Retrieve a pull request suggestion for a particular repository or team project.
     * 
     * @param repositoryId - ID of the git repository.
     * @param project - Project ID or project name
     * @param preferCompareBranch - If true, prefer the compare branch over the default branch as target branch for pull requests.
     */
    getSuggestions(repositoryId: string, project?: string, preferCompareBranch?: boolean): Promise<Git.GitSuggestion[]>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Retrieve a pull request suggestion for a particular repository or team project.
     * 
     * @param repositoryId - ID of the git repository.
     * @param project - Project ID or project name
     * @param preferCompareBranch - If true, prefer the compare branch over the default branch as target branch for pull requests.
     */
    public async getSuggestions(
        repositoryId: string,
        project?: string,
        preferCompareBranch?: boolean
        ): Promise<Git.GitSuggestion[]> {

        const queryValues: any = {
            preferCompareBranch: preferCompareBranch
        };

        return this.beginRequest<Git.GitSuggestion[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/suggestions",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            queryParams: queryValues
        });
    }

}

export const GitClientName = "Repos.Messages.Git.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
